<template>
  <div
    id="filters"
    class="filters"
  >
    <FiltersHeader />

    <FiltersContent />
  </div>
</template>
